import React from "react";
import Home from "./pages/Home";
import { Routes, Route } from "react-router-dom";
import Contact from "./pages/Contact";
import Aboutus from "./pages/Aboutus";
import OurServices from "./pages/OurServices";
import NewQuote from "./pages/NewQuote";
import Terms from "./pages/Terms";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import Qoute from "./front-components/Quote";
import Payment from "./pages/Payment";
import TermsUse from "./pages/TermsUse";
import TermsShipping from "./pages/TermsShipping";
import Disclaimer from "./pages/Disclaimer";
import Restriction from "./pages/Restriction";
import Login from "./pages/Login";
import Register from "./pages/Register";
import { CustomerProvider } from "../context/CustomerContext";
import Profile from "./pages/Profile";
import Txns from "./pages/Txns";
import Price from "./pages/Price";
import ScrollToTop from "./front-components/ScrollToTop";
import BookingReceipt from "./pages/BookingReceipt";

export default function FrontendRoute() {
  return (
    <CustomerProvider>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/services" element={<OurServices />} />
        <Route path="/newQuote" element={<NewQuote />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/refundPolicy" element={<RefundPolicy />} />
        <Route path="/distanceDetails" element={<Qoute />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/booking-receipt" element={<BookingReceipt />} />
        <Route path="/termsofuse" element={<TermsUse />} />
        <Route path="/termsofshipping" element={<TermsShipping />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/restrictions" element={<Restriction />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/bookings" element={<Txns />} />
        <Route path="/pricing" element={<Price />} />
      </Routes>
    </CustomerProvider>
  );
}
